import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiCall_domain } from "../api";
import Spinner from "../Spinner/Spinner";
import { useHistory } from "routerCompat";
import PulseLoader from "react-spinners/PulseLoader";
import Header from "../header";
import toast from "react-hot-toast";
import CustomDatePicker from "../global/DatePicker";
export default function AddReminder() {
  const [car, setCar] = useState({
    current_mileage: 0,
    average_monthly_consumption: 0,
  });
  const [oldValue, setOldValue] = useState([]);
  const [futureValue, setFutureValue] = useState([]);
  const [fields, setFields] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updateLoader, setUpdateLoader] = useState(false);
  const history = useHistory();
  useEffect(() => {
    if (localStorage.getItem("carId2")) {
      const headers = {
        Authorization: localStorage.getItem("Api_key"),
        "content-type": "application/json",
      };
      axios
        .get(
          `${apiCall_domain}/customer/reminder/car/fields/${localStorage.getItem(
            "carId2",
          )}`,
          { headers },
        )
        .then((res) => {
          setFields(res.data.data.fields);
          setCar({
            current_mileage: res.data.data.car.current_mileage,
            average_monthly_consumption:
              res.data.data.car.average_monthly_consumption,
          });
          let ov = [];
          let fv = [];
          res.data.data.fields.map((item) => {
            ov.push({
              field_id: item.id,
              old_value: item.old_value,
              type: item.type,
            });
            fv.push({
              field_id: item.id,
              future_value: item.future_value,
              type: item.type,
            });
          });
          setOldValue([...ov]);
          setFutureValue([...fv]);
          setLoading(false);
        });
    }
  }, []);
  const mileageHandler = (type, e) => {
    type == "current_mileage"
      ? setCar({ ...car, current_mileage: e.target.value })
      : setCar({ ...car, average_monthly_consumption: e.target.value });
  };
  const inputHandler = (type, value) => {
    if (type == "old_value") {
      let data = oldValue;
      data = data?.map((u) => (u.field_id !== value.field_id ? u : value));
      setOldValue(data);
    } else if (type == "future_value") {
      let data = futureValue;
      data = data?.map((u) => (u.field_id !== value.field_id ? u : value));
      setFutureValue(data);
    }
  };
  const update = () => {
    let allData = [];
    for (let ov of oldValue) {
      for (let fv of futureValue) {
        if (ov.field_id == fv.field_id) {
          let obj;
          if (ov.old_value || fv.future_value) {
            obj = { ...fv, ...ov };
          }
          if (allData.includes(obj) === false && obj) allData.push(obj);
        }
      }
    }
    if (!car.current_mileage) {
      toast.error("لطفا کیلومتر فعلی خودرو خود را وارد کنید");
    } else if (!car.average_monthly_consumption) {
      toast.error("لطفا مصرف متوسط ماهانه خودرو خود را وارد کنید ");
    } else {
      setUpdateLoader(true);
      const fields = {
        fields: allData,
        current_mileage: +car.current_mileage,
        average_monthly_consumption: +car.average_monthly_consumption,
        customer_car_id: localStorage.getItem("carId2"),
      };
      const Headers = {
        Authorization: localStorage.getItem("Api_key"),
        "content-type": "application/json",
      };
      axios
        .post(`${apiCall_domain}/customer/reminder/car/fields`, fields, {
          headers: Headers,
        })
        .then((res) => {
          history.push("/carSelection");
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
          setUpdateLoader(false);
        });
    }
  };

  let time = new Date();
  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <div className="addReminderUpdate">
          <Header
            showSearchBar={true}
            title="بروز رسانی خودرو"
            backUrl="/carSelection"
          />
          <button className="upadteReminder" onClick={update}>
            {updateLoader ? (
              <PulseLoader size={10} color="#fff" loading={true} />
            ) : (
              "به روز رسانی"
            )}
          </button>
          <div className="addReminderCom">
            <div className="CurrentCarMileage">
              <div className="currentMilaege">
                <span className="text">کیلومتر فعلی خودرو</span>
                <input
                  inputMode="numeric"
                  type="text"
                  placeholder="13000"
                  name="current_mileage"
                  value={car.current_mileage}
                  onChange={(e) => mileageHandler("current_mileage", e, "num")}
                />
              </div>
              <div className="currentMilaege">
                <span className="text">مصرف متوسط ماهانه</span>
                <input
                  inputMode="numeric"
                  type="text"
                  placeholder="13000"
                  name="average_monthly_consumption"
                  value={car.average_monthly_consumption}
                  onChange={(e) =>
                    mileageHandler("average_monthly_consumption", e, "num")
                  }
                />
              </div>
            </div>
            {fields.map((item) => (
              <div className="fieldsReminder">
                <div className="text">{item.key}</div>
                {item.type === 0 ? (
                  <>
                    <input
                      inputMode="numeric"
                      type="text"
                      value={
                        oldValue.find((u) => {
                          if (u.field_id == item.id) return u;
                        }).old_value
                      }
                      placeholder={`${item.key}`}
                      onChange={(e) =>
                        inputHandler("old_value", {
                          field_id: item.id,
                          type: 0,
                          old_value: e.target.value,
                        })
                      }
                    />
                  </>
                ) : (
                  <CustomDatePicker
                    onChange={(e) =>
                      inputHandler("old_value", {
                        field_id: item.id,
                        type: 1,
                        old_value: e,
                      })
                    }
                    date={
                      oldValue.find((u) => {
                        if (u.field_id == item.id) return u;
                      })?.old_value || time
                    }
                    timePicker={false}
                  />
                )}
                <div className="text">{item.future_key}</div>
                {item.type === 0 ? (
                  <input
                    inputMode="numeric"
                    type="text"
                    placeholder={`${item.future_key}`}
                    onChange={(e) =>
                      inputHandler("future_value", {
                        field_id: item.id,
                        type: 0,
                        future_value: e.target.value,
                      })
                    }
                    value={
                      futureValue.find((u) => {
                        if (u.field_id == item.id) return u;
                      }).future_value
                    }
                  />
                ) : (
                  <CustomDatePicker
                    onChange={(e) =>
                      inputHandler("future_value", {
                        field_id: item.id,
                        type: 1,
                        future_value: e,
                      })
                    }
                    date={
                      futureValue.find((u) => {
                        if (u.field_id == item.id) return u;
                      })?.future_value || time
                    }
                    timePicker={false}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
